import { useQuery } from "@tanstack/react-query";
import { getDealManagerDeals } from "@/api";
import { useAuth } from "@/contexts";
import { Deal } from "@/types";

export const useDealManagerDeals = () => {
  const { user } = useAuth()
  const query = useQuery<Deal[]>({
    queryKey: ["dealManagerDeals"],
    queryFn: () => getDealManagerDeals(),
    // Same gate as useDealManagerClients: deal-manager-only endpoint, answering
    // 403 for anyone else, so a client should never spend the round trip.
    enabled: user?.userType === "deal_manager",
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};
